var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooter3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 224,
    height: 39,
    viewBox: "0 0 224 39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_62678",
    "data-name": "Group 62678",
    transform: "translate(-86 -636.49)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_16387",
    "data-name": "Rectangle 16387",
    transform: "translate(86 636.49)",
    fill: "#fff",
    stroke: "#d3d3d3",
    strokeMiterlimit: 10,
    strokeWidth: 0.7
  }, /*#__PURE__*/React.createElement("rect", {
    width: 224,
    height: 39,
    rx: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.35,
    y: 0.35,
    width: 223.3,
    height: 38.3,
    rx: 0.65,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Privacy_Statement",
    "data-name": "Privacy Statement",
    transform: "translate(258 658)",
    fill: "#1072c6",
    fontSize: 5,
    fontFamily: "OpenSans-Semibold, Open Sans",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Privacy Statement")), /*#__PURE__*/React.createElement("text", {
    id: "Disclaimer",
    transform: "translate(251 658)",
    fill: "#1072c6",
    fontSize: 5,
    fontFamily: "OpenSans-Semibold, Open Sans",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -25.479,
    y: 0
  }, "Disclaimer")), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-image",
    "data-name": "Icon awesome-image",
    d: "M18.372,19.1H1.9A1.864,1.864,0,0,1,0,17.272V6.325A1.864,1.864,0,0,1,1.9,4.5H18.372a1.864,1.864,0,0,1,1.9,1.825V17.272A1.864,1.864,0,0,1,18.372,19.1ZM4.435,6.629A2.174,2.174,0,0,0,2.217,8.757a2.174,2.174,0,0,0,2.217,2.129A2.174,2.174,0,0,0,6.652,8.757,2.174,2.174,0,0,0,4.435,6.629Zm-1.9,10.035h15.2V12.406L14.274,9.08a.489.489,0,0,0-.672,0L8.236,14.231l-2.2-2.11a.489.489,0,0,0-.672,0L2.534,14.839Z",
    transform: "translate(94.109 644.191)",
    fill: "#babec1"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Copyright_2020._The_Landmark_Trust_Banking_Corporation_Limited._",
    "data-name": "Copyright 2020. The Landmark Trust Banking Corporation Limited. ",
    transform: "translate(128 647)",
    fill: "#3a3a3a",
    fontSize: 5,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 5
  }, "Copyright 2020. The Landmark "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 11
  }, "Trust Banking Corporation "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 17
  }, "Limited. ")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooter3);
export default __webpack_public_path__ + "static/media/footer3.5fa9d2bccc01a6d00c9c62437ddd7b07.svg";
export { ForwardRef as ReactComponent };